var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayoutGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_244_2603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99984 2.66669H3.33317C2.96498 2.66669 2.6665 2.96516 2.6665 3.33335V6.00002C2.6665 6.36821 2.96498 6.66669 3.33317 6.66669H5.99984C6.36803 6.66669 6.6665 6.36821 6.6665 6.00002V3.33335C6.6665 2.96516 6.36803 2.66669 5.99984 2.66669Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 2.66669H10.0002C9.63197 2.66669 9.3335 2.96516 9.3335 3.33335V6.00002C9.3335 6.36821 9.63197 6.66669 10.0002 6.66669H12.6668C13.035 6.66669 13.3335 6.36821 13.3335 6.00002V3.33335C13.3335 2.96516 13.035 2.66669 12.6668 2.66669Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99984 9.33331H3.33317C2.96498 9.33331 2.6665 9.63179 2.6665 9.99998V12.6666C2.6665 13.0348 2.96498 13.3333 3.33317 13.3333H5.99984C6.36803 13.3333 6.6665 13.0348 6.6665 12.6666V9.99998C6.6665 9.63179 6.36803 9.33331 5.99984 9.33331Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 9.33331H10.0002C9.63197 9.33331 9.3335 9.63179 9.3335 9.99998V12.6666C9.3335 13.0348 9.63197 13.3333 10.0002 13.3333H12.6668C13.035 13.3333 13.3335 13.0348 13.3335 12.6666V9.99998C13.3335 9.63179 13.035 9.33331 12.6668 9.33331Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_244_2603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutGrid);
export default __webpack_public_path__ + "static/media/layout-grid.504b20038a2c2600b8f926473a68a5ac.svg";
export { ForwardRef as ReactComponent };